module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAA7SURBVEiJY2SAgq1szPcZGBgVGKgK/j9goq6Bo2AUjIIBAYz4JCkvPkaLilEwCoYHYKRNawIG6FBUAAA0rQrh1YadIQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/List.png
// module id = YqOE
// module chunks = 1